import { getGlobalProps } from '../utils/queryHelpers';

const Product = () => {
  const {
    orgInfo: {
      config: { defaultWeightUnit = '', defaultCurrency }
    }
  } = getGlobalProps();

  return {
    id: null,
    sku: '',
    description: '',
    rowVersion: '',
    name: '',
    packageTypeId: null,
    pieceCount: null,
    hazMat: {},
    freightInfo: {},
    weightInfo: {
      weightUnit: defaultWeightUnit
    },
    valueInfo: {
      currency: defaultCurrency
    },
    isHazMat: false,
    requiresDensityValidation: false
  };
};

export default Product;
